import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_POWERBOX_LIST = createRequestTypes('GET_POWERBOX_LIST');
export const GET_POWERBOX = createRequestTypes('GET_POWERBOX');
export const CREATE_POWERBOX = createRequestTypes('CREATE_POWERBOX');
export const ASSIGN_POWERBOX = createRequestTypes('ASSIGN_POWERBOX');
export const UPDATE_POWERBOX = createRequestTypes('UPDATE_POWERBOX');
export const DELETE_POWERBOX = createRequestTypes('DELETE_POWERBOX');
export const SET_POWERBOX_TABLE_FILTER = 'SET_POWERBOX_TABLE_FILTER';
export const SET_POWERBOX_TABLE_SORTING = 'SET_POWERBOX_TABLE_SORTING';

export const getPowerboxList = {
  request: (data) => action(GET_POWERBOX_LIST[REQUEST], { data }),
  success: (payload) => action(GET_POWERBOX_LIST[SUCCESS], { payload }),
  failure: (payload) => action(GET_POWERBOX_LIST[FAILURE], { payload }),
};

export const getPowerbox = {
  request: (id) => action(GET_POWERBOX[REQUEST], { id }),
  success: (payload) => action(GET_POWERBOX[SUCCESS], { payload }),
  failure: (payload) => action(GET_POWERBOX[FAILURE], { payload }),
};

export const createPowerbox = {
  request: (data) => action(CREATE_POWERBOX[REQUEST], { data }),
  success: (payload) => action(CREATE_POWERBOX[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_POWERBOX[FAILURE], { payload }),
};

export const updatePowerbox = {
  request: (id, data) => action(UPDATE_POWERBOX[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_POWERBOX[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_POWERBOX[FAILURE], { payload }),
};

export const assignPowerbox = {
  request: (id, data) => action(ASSIGN_POWERBOX[REQUEST], { id, data }),
  success: (payload) => action(ASSIGN_POWERBOX[SUCCESS], { payload }),
  failure: (payload) => action(ASSIGN_POWERBOX[FAILURE], { payload }),
};

export const deletePowerbox = {
  request: (id) => action(DELETE_POWERBOX[REQUEST], { id }),
  success: (payload) => action(DELETE_POWERBOX[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_POWERBOX[FAILURE], { payload }),
};

export const setPowerboxTableFilter = (payload) => ({
  type: SET_POWERBOX_TABLE_FILTER,
  payload,
});

export const setPowerboxTableSorting = (payload) => ({
  type: SET_POWERBOX_TABLE_SORTING,
  payload,
});
